module.exports = __webpack_public_path__ + "static/fabric-image-fit-contain-fd64e0fa1ad04008830c27da149f1947.png";